module.exports = __webpack_public_path__ + "static/media/M1-5-Nubro-Ody-cod104.f52f4c63.png";